export default __webpack_public_path__ + "static/media/clearFiltersNew.7bfd2f2a.svg";